export const GET_VISIBILITY_REPORTS = 'GET_VISIBILITY_REPORTS';
export const GET_VISIBILITY_REPORT = 'GET_VISIBILITY_REPORT';
export const GET_SHARED_VISIBILITY_REPORT = 'GET_SHARED_VISIBILITY_REPORT';
